import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import { IS_CHINA } from 'constants/environments'
import { PATH as ORIG_PATH, SOCIAL_MEDIA_URL } from 'constants/urls'
import { EMAIL_ADDRESS, TEL_NUMBER } from 'constants/contactInfos'
import {
  Container,
  LinkColumnContainer,
  AboutSection,
  HelpSection,
  ContactSection,
  LanguageSection,
  SectionTitle,
  SocialMediaIcons,
  SocialMediaIcon,
  ContactUsIcon,
  ServiceHour,
  ExtraInfo,
} from './index.style'
import LanguageSelector from './LanguageSelector'

function Footer({ baseUrl }) {
  const { t } = useTranslation('general')
  const PATH = ORIG_PATH(baseUrl)
  const IS_MY = baseUrl === '/my'
  const IS_HK = baseUrl === '/hk'

  const NEW_TAB_ATTR = {
    target: '_blank',
    rel: 'noreferrer',
  }

  const ABOUT_COLUMN = [
    {
      key: 'Features',
      href: PATH.ABOUT_PRODUCT,
    },
    {
      key: 'Team',
      href: PATH.ABOUT_TEAM,
    },
    {
      key: IS_CHINA ? 'Terms of Use - CN' : 'Terms of Use',
      href: PATH.TERMS_OF_USE,
      attr: NEW_TAB_ATTR,
    },
    ...(IS_CHINA
      ? []
      : [
          {
            key: 'Privacy Policy',
            href: PATH.PRIVACY_POLICY,
            attr: NEW_TAB_ATTR,
          },
        ]),
  ]

  const SOCIAL_MEDIA_ICONS = IS_CHINA
    ? {
        weibo: {
          href: SOCIAL_MEDIA_URL.WEIBO,
          icon: <SocialMediaIcon.Weibo />,
        },
        youku: {
          href: SOCIAL_MEDIA_URL.YOUKU,
          icon: <SocialMediaIcon.Youku />,
        },
      }
    : {
        youtube: {
          href: SOCIAL_MEDIA_URL.YOUTUBE,
          icon: <SocialMediaIcon.YouTube />,
        },
        facebook: {
          href: IS_MY
            ? SOCIAL_MEDIA_URL.FACEBOOK_MY
            : SOCIAL_MEDIA_URL.FACEBOOK,
          icon: <SocialMediaIcon.Facebook />,
        },
      }

  const HELP_COLUMN = [
    {
      key: 'FAQs',
      href: PATH.HELP_CENTER,
    },
    {
      key: 'Videos',
      href: IS_CHINA
        ? SOCIAL_MEDIA_URL.YOUKU
        : SOCIAL_MEDIA_URL.YOUTUBE_LEARNING,
      attr: NEW_TAB_ATTR,
    },
  ]

  const MAIL =
    (IS_CHINA && EMAIL_ADDRESS.CN) ||
    (IS_MY && EMAIL_ADDRESS.MY) ||
    (IS_HK && EMAIL_ADDRESS.HK) ||
    EMAIL_ADDRESS.GLOBAL

  const TEL = (IS_CHINA && TEL_NUMBER.CN) ||
    (IS_MY && TEL_NUMBER.MY) ||
    (IS_HK && TEL_NUMBER.HK) || (
      <>
        {TEL_NUMBER.GLOBAL}
        <ServiceHour>{t('Footer.Service Hour')}</ServiceHour>
      </>
    )

  return (
    <Container>
      <LinkColumnContainer>
        <AboutSection>
          <SectionTitle>PaGamO</SectionTitle>
          <ul>
            {ABOUT_COLUMN.map(item => (
              <li key={item.key}>
                <a href={item.href} {...item.attr}>
                  {t(`Footer.${item.key}`)}
                </a>
              </li>
            ))}
            <SocialMediaIcons>
              {Object.entries(SOCIAL_MEDIA_ICONS).map(
                ([key, { href, icon }]) => (
                  <a key={key} href={href} {...NEW_TAB_ATTR}>
                    {icon}
                  </a>
                )
              )}
            </SocialMediaIcons>
            {IS_CHINA && <li>官方QQ群: 296897008</li>}
          </ul>
        </AboutSection>
        <HelpSection>
          <SectionTitle>{t('Footer.Help')}</SectionTitle>
          <ul>
            {HELP_COLUMN.map(item => (
              <li key={item.key}>
                <a href={item.href} {...item.attr}>
                  {t(`Footer.${item.key}`)}
                </a>
              </li>
            ))}
          </ul>
        </HelpSection>
        <ContactSection>
          <SectionTitle>{t('Footer.Contact Us')}</SectionTitle>
          <ul>
            <li>
              <ContactUsIcon.Mail />
              {MAIL}
            </li>
            <li>
              <ContactUsIcon.Tel />
              {TEL}
            </li>
          </ul>
        </ContactSection>
        <LanguageSection>
          <SectionTitle>{t('Footer.Language')}</SectionTitle>
          <LanguageSelector isMy={IS_MY} />
        </LanguageSection>
      </LinkColumnContainer>
      <ExtraInfo>
        {IS_CHINA && (
          <p>
            <a href="https://beian.miit.gov.cn/" {...NEW_TAB_ATTR}>
              沪ICP备17041942号-1
            </a>
          </p>
        )}
        <p>Copyright &copy; BoniO Inc. All Rights Reserved.</p>
      </ExtraInfo>
    </Container>
  )
}

Footer.propTypes = {
  baseUrl: PropTypes.string,
}

export default Footer
